(() => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');

  if (toggle && nav) {
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const backgroundRegions = [document.querySelector('main'), document.querySelector('footer')].filter(Boolean);
    let previousFocus = null;

    const setMenu = (open, returnFocus = false) => {
      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      nav.hidden = !open;
      document.body.classList.toggle('menu-open', open);

      backgroundRegions.forEach((region) => region.toggleAttribute('inert', open));

      if (open) {
        previousFocus = document.activeElement;
        window.requestAnimationFrame(() => nav.querySelector(focusableSelector)?.focus());
      } else if (wasOpen && returnFocus) {
        (previousFocus instanceof HTMLElement ? previousFocus : toggle).focus();
      }
    };

    toggle.addEventListener('click', () => {
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      setMenu(willOpen, !willOpen);
    });
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (event) => {
      if (toggle.getAttribute('aria-expanded') !== 'true') return;

      if (event.key === 'Escape') {
        event.preventDefault();
        setMenu(false, true);
        return;
      }

      if (event.key === 'Tab') {
        const focusable = [toggle, ...nav.querySelectorAll(focusableSelector)].filter((element) => !element.hidden);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1050) setMenu(false);
    });
  }
})();
